import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';

import Content from './content/content';
import './App.css';

import EVgo_FC_color_transparent from './component/img/EVgo_FC_color_transparent.png';
import logoBorrow from './component/img/logo-borrow.png';

export default class App extends Component {
  render() {
    return (
      <Container className="container">
        <header>
          <div className="header_img_container">
            <img className="header_img" src={ EVgo_FC_color_transparent } alt="" />
            <img className="borrow_header_img" src={ logoBorrow } alt="" />
          </div>
        </header>

        <Content/>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js